export const ADD_SUBSCRIBER_ENDPOINT = '/lists/addSubscriberQueryJson';
export const DELETE_USERS_IN_LIST_ENDPOINT = '/lists/deleteUsersInList';
export const EXPORT_TO_CSV_ENDPOINT = '/lists/export.csv';
export const EXPORT_DIAGNOSTIC_INFORMATION_ENDPOINT = '/lists/diagnosticInfo.zip';
export const EXPORT_FACEBOOK_CUSTOM_AUDIENCE_ENDPOINT = '/lists/exportFacebookCustomAudience';
export const LISTS_BY_ID_ENDPOINT = `/lists/getListById`;
export const LIST_FIELD_FACETS = '/lists/fieldFacets';
export const LIST_SIZE_ENDPOINT = '/i/lists/getSize';
export const LISTS_JSON_ENDPOINT = `/lists/data.json`;
export const SAVE_AS_NEW_LIST_ENDPOINT = '/lists/createListFromQuery';
export const SEGMENT_USERS_QUERY = '/lists/segmentUsersQuery';
export const UPDATE_DYNAMIC_LIST_ENDPOINT = '/lists/updateDynamicListQuery';
export const UPDATE_LIST_DESCRIPTION_ENDPOINT = '/lists/changeDescription';
export const UPDATE_LIST_NAME_ENDPOINT = '/lists/rename';
export const VALIDATE_LISTS_QUERY = '/lists/validateQuery';
